/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileFontSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileFontSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m9.464 8.152-3.13 9.696h1.18l.963-2.983h3.65l.963 2.983h1.18l-3.13-9.696H9.463Zm-.625 5.594 1.463-4.533 1.463 4.533H8.84ZM18.543 13v.659a1.451 1.451 0 0 0-1.311-.66c-1.525 0-2.435.907-2.435 2.425 0 1.518.91 2.424 2.435 2.424a1.416 1.416 0 0 0 1.311-.808v.808h1.124V13h-1.124Zm-1.311 3.73c-.907 0-1.311-.404-1.311-1.306s.404-1.305 1.31-1.305c.907 0 1.312.402 1.312 1.305 0 .902-.405 1.305-1.311 1.305Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m6.333 17.848 3.131-9.696h1.675l3.131 9.696h-.162l-2.969-9.193H9.464l-2.968 9.193h-.163Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m9.001 13.746-.162.503h2.926l-.162-.503H9Zm9.542-.243V13h1.124v.503h-1.124Zm0 .156a1.451 1.451 0 0 0-1.311-.66c-1.525 0-2.435.907-2.435 2.425 0 .086.003.17.009.252.096-1.366.988-2.173 2.426-2.173a1.46 1.46 0 0 1 1.311.659v-.504Zm-2.61 2.017c.072.726.481 1.053 1.299 1.053.817 0 1.227-.327 1.3-1.053.007.079.011.163.011.251 0 .903-.405 1.306-1.311 1.306-.907 0-1.311-.403-1.311-1.306a2.5 2.5 0 0 1 .012-.251Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileFontSmall
};
